/**
 * Canonical surface paths and legacy redirects (RSW-330).
 */
import { normalizePathname } from './appSurfaceRoutes';

const JOBSEEKER_MODULE_PATHS = new Set([
  '/tracker',
  '/jobs',
  '/profile',
  '/settings',
  '/cover',
  '/interview',
  '/assessments',
]);

/**
 * Map a legacy pathname to its canonical equivalent, or null if already canonical.
 * `/dashboard` was the old counselor home; jobseekers hitting it must stay in
 * workspace (RSW-446) instead of landing on caseload.
 * @param {string} pathname
 * @param {{ userType?: string | null }} [options]
 * @returns {string|null}
 */
export function mapLegacyPathToCanonical(pathname, { userType } = {}) {
  const path = normalizePathname(pathname);

  const counselorDetail = path.match(/^\/counselor\/jobseekers\/([^/]+)(\/library|\/mirror)?$/);
  if (counselorDetail) {
    const [, id, suffix = ''] = counselorDetail;
    return `/jobseekers/${id}${suffix}`;
  }

  if (path === '/dashboard') {
    return userType === 'JOBSEEKER' ? '/workspace' : '/caseload';
  }

  const staticMap = {
    '/counselor/caseload': '/caseload',
    '/counselor/team': '/team',
    '/counselor': '/caseload',
    '/app/workspace': '/workspace',
    '/app/home': '/workspace',
    '/app/build': '/workspace',
    '/app': '/workspace',
    '/app/legacy': '/workspace',
    '/app/tracker': '/tracker',
    '/app/jobs': '/jobs',
    '/app/profile': '/profile',
    '/app/settings': '/settings',
    '/app/cover': '/cover',
    '/app/interview': '/interview',
    '/app/assessments': '/assessments',
  };

  if (staticMap[path]) return staticMap[path];
  return null;
}

export function isCanonicalPortalPath(pathname) {
  const path = normalizePathname(pathname);
  if (path === '/caseload' || path === '/team' || path === '/job-board') return true;
  return /^\/jobseekers\/[^/]+(\/library|\/mirror)?$/.test(path);
}

export function isCanonicalJobseekerPath(pathname) {
  const path = normalizePathname(pathname);
  if (path === '/workspace' || path.startsWith('/access/')) return true;
  return JOBSEEKER_MODULE_PATHS.has(path);
}
